import { render, staticRenderFns } from "./CatalogsReload.vue?vue&type=template&id=287e9bd0&scoped=true"
import script from "./CatalogsReload.vue?vue&type=script&lang=ts"
export * from "./CatalogsReload.vue?vue&type=script&lang=ts"
import style0 from "./CatalogsReload.vue?vue&type=style&index=0&id=287e9bd0&prod&scoped=true&lang=css"
import style1 from "./CatalogsReload.vue?vue&type=style&index=1&id=287e9bd0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e9bd0",
  null
  
)

export default component.exports